import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useApolloClient } from 'react-apollo';

import getAccountCardPreviewFileQuery from '../../graphql/queries/getAccountCardPreviewFile';
import NativeActivityIndicator from '../../../../components/global/NativeActivityIndicator';
import sleep from '../../../../util/sleep';

const propTypes = {
  className: PropTypes.string,
  accountCardId: PropTypes.string.isRequired,
  retries: PropTypes.number,
  retryInterval: PropTypes.number,
  fallback: PropTypes.node,
};

const AccountCardPreviewFile = ({
  className,
  accountCardId,
  retries = 5,
  retryInterval = 2000,
  fallback,
}) => {
  const client = useApolloClient();
  const [loadingAccountCard, setLoadingAccountCard] = useState(false);
  const [accountCard, setAccountCard] = useState(false);
  const [previewLoadError, setPreviewLoadError] = useState(false);

  // TODO convert this to useLazyQuery when Luis decides to merge Apollo 3.0 :p
  const getAccountCard = async () => {
    return client.query({
      query: getAccountCardPreviewFileQuery,
      variables: {
        id: accountCardId,
      },
      fetchPolicy: 'network-only',
    });
  };

  const handleAccountCardFetch = async ({ remaining, fetchedAccountCard }) => {
    if (!remaining && !fetchedAccountCard?.front_preview_file_url) {
      setPreviewLoadError(true);
    }

    if (loadingAccountCard || !remaining) {
      return;
    }

    setLoadingAccountCard(true);
    await sleep(retryInterval);
    const { data = {} } = await getAccountCard();
    setLoadingAccountCard(false);
    setAccountCard(data.accountCard);

    if (!accountCard?.front_preview_file_url) {
      await handleAccountCardFetch({
        remaining: remaining - 1,
        fetchedAccountCard: data.accountCard,
      });
    }
  };

  useEffect(() => {
    handleAccountCardFetch({ remaining: retries });
  }, []);

  const previewUrl = accountCard?.front_preview_file_url;
  const isLoading = !previewUrl && !previewLoadError;
  const classes = classNames({
    [className]: !!className,
    'account-card-preview-file': true,
    'is-loading': isLoading,
    'is-failed': previewLoadError,
  });

  return (
    <div className={classes}>
      {isLoading && <NativeActivityIndicator size="xs" />}
      {previewUrl ? <img src={previewUrl} alt="" /> : fallback}
    </div>
  );
};

AccountCardPreviewFile.propTypes = propTypes;

export default AccountCardPreviewFile;
